import {Button, TextInput} from "omoplay";
import {useEffect, useState} from "react";
import CardSelectForm from "./CardSelectForm";

const AiCreditChargeForm = ({onSelectedCard, onChargeAmount}) => {
    const [chargeCredit, setChargeCredit] = useState(100)

    useEffect(() => {
        onChargeAmount(chargeCredit * 10)
    }, [chargeCredit]);

    return (
        <>
            <div className="flex-col gap-2">
                <div className="flex-col gap-1">
                    <div className="flex gap-2">
                        <div className="font-medium text-[16px]">충전 Credit</div>
                        {
                            chargeCredit < 100 && (
                                <label className="text-red-500 font-medium text-[16px]">
                                    * 결제는 100 Credit 이상 가능합니다.
                                </label>
                            )
                        }
                    </div>
                    <div className="flex-align-center gap-2">
                        <TextInput type="numeric" value={chargeCredit} onChange={(e) => {
                            const num = Number(e.target.value)
                            if (!isNaN(num)) {
                                setChargeCredit(num)
                            }
                        }
                        } size={7} />
                        <div>Credit</div>
                    </div>
                </div>
                <div className="flex gap-2">
                    <Button variants="default" size="normal" value="+ 100 Credit" onClick={() => setChargeCredit(prev => prev + 100)} />
                    <Button variants="default" size="normal" value="+ 500 Credit" onClick={() => setChargeCredit(prev => prev + 500)} />
                    <Button variants="default" size="normal" value="+ 1,000 Credit" onClick={() => setChargeCredit(prev => prev + 1000)} />
                </div>
            </div>
            <div className="border" style={{margin: "36px 0"}}></div>
            <CardSelectForm onSelected={onSelectedCard} />
            <div className="w-full flex-col items-end mt-[20px]">
                <label className="font-medium text-[16px]">
                    충전 Credit: {chargeCredit.toLocaleString()} Credit
                </label>
                <label className="font-medium text-[18px] text-primary">
                    총 결제 금액: {(chargeCredit * 10).toLocaleString()}원 (KRW)
                </label>
            </div>
        </>
    )
}

export default AiCreditChargeForm